import script from "./AcademyMineView.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyMineView.vue?vue&type=script&setup=true&lang=js"

import "./AcademyMineView.vue?vue&type=style&index=0&id=9ca9f0ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_db7f3463623555724ece677ccfae2485/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca9f0ac"]])

export default __exports__